import classNames from 'classnames';
import textClassSwitcher from '../../utils/textClassSwitcher';
import { tagsDescription } from '../Tags.css';
import type { TTagsAttributes } from '../Tags.types';

interface Props {
  description: string;
  className?: string;
  attributes: TTagsAttributes;
}

const Description = ({ description, className = '', attributes }: Props) => {
  return (
    <span
      className={classNames(
        tagsDescription,
        textClassSwitcher(className, attributes?.descriptionFontSize || 'text-sm'),
      )}
    >
      {description}
    </span>
  );
};

export default Description;
